import type { WorkOrderSeverity, WorkOrderSource, WorkOrderState } from '@chukua/common';

export const WORK_ORDER_STATE_LABELS: Record<WorkOrderState, string> = {
  raised: 'Raised',
  approved: 'Approved',
  scheduled: 'Scheduled',
  in_progress: 'In progress',
  completed: 'Completed',
  verified_closed: 'Verified',
  cancelled: 'Cancelled',
};

/** Ant Tag presets, which follow the brand palette. */
export const WORK_ORDER_STATE_COLORS: Record<WorkOrderState, string> = {
  raised: 'blue',
  approved: 'cyan',
  scheduled: 'purple',
  in_progress: 'warning',
  completed: 'gold',
  verified_closed: 'success',
  cancelled: 'default',
};

export const WORK_ORDER_SEVERITY_LABELS: Record<WorkOrderSeverity, string> = { critical: 'Critical', scheduled: 'Scheduled', monitor: 'Monitor' };

export const WORK_ORDER_SEVERITY_COLORS: Record<WorkOrderSeverity, string> = { critical: 'error', scheduled: 'default', monitor: 'blue' };

export const WORK_ORDER_SOURCE_LABELS: Record<WorkOrderSource, string> = {
  scheduled_service: 'Scheduled service',
  defect: 'Defect',
  road_incident: 'Road incident',
  inspection_finding: 'Inspection finding',
};

export function workOrderNumber(sequenceNumber: number): string {
  return `WO-${sequenceNumber}`;
}
